module.exports = __webpack_public_path__ + "static/media/Samsung Galaxy S8 Orchid Gray.f064bb52.png";